var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _g, _path235, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTokenGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  },
  viewBox: "0 0 292 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, black)",
  fillOpacity: 0.25,
  d: "M123.665 157.258c26.404 0 47.898 5.253 48.674 11.807 8.673-1.995 20.249-3.213 32.964-3.213 26.894 0 48.696 5.45 48.697 12.173 0 6.724-21.803 12.175-48.697 12.175q-.76 0-1.514-.007c-1.115 4.811-13.478 8.601-28.563 8.601-15.82 0-28.644-4.168-28.645-9.31 0-3.185 4.922-5.995 12.429-7.673-1.415-1.082-2.241-2.228-2.382-3.419-7.366 1.694-16.826 2.828-27.3 3.131-1.316 6.43-22.585 11.542-48.63 11.542-26.895 0-48.698-5.451-48.698-12.174 0-6.245 18.807-11.391 43.032-12.092 1.318-6.43 22.588-11.541 48.633-11.541"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 171.413c18.39 0 33.298-5.206 33.298-11.627s-14.908-11.627-33.298-11.627-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 170.07c18.39 0 33.298-5.206 33.298-11.627s-14.908-11.627-33.298-11.627-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 147.438c-18.39 0-33.298 5.205-33.298 11.627 0 6.421 14.908 11.626 33.298 11.626s33.299-5.205 33.299-11.626c0-6.424-14.913-11.629-33.304-11.627zm0 21.849c-16.173 0-29.283-4.578-29.282-10.225 0-5.646 13.111-10.224 29.284-10.224 16.171 0 29.282 4.578 29.281 10.225 0 5.646-13.109 10.224-29.281 10.224z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__a)",
  d: "M135.57 146.816c-18.39 0-33.298 5.206-33.298 11.627s14.908 11.627 33.298 11.627 33.299-5.206 33.299-11.627c0-6.424-14.913-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.577-29.282-10.224s13.11-10.224 29.282-10.224 29.283 4.577 29.283 10.224c0 5.644-13.106 10.222-29.277 10.224z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 159.445c15.929 0 28.841-2.602 28.841-5.813s-12.912-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.913 5.813 28.841 5.813",
  opacity: 0.15
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 160.589c18.39 0 33.298-5.206 33.298-11.627s-14.908-11.627-33.298-11.627-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 159.246c18.39 0 33.298-5.206 33.298-11.627s-14.908-11.627-33.298-11.627-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 136.613c-18.39 0-33.298 5.205-33.298 11.626 0 6.422 14.908 11.627 33.298 11.627s33.299-5.205 33.299-11.627-14.913-11.628-33.304-11.626zm0 21.849c-16.173 0-29.283-4.578-29.282-10.225 0-5.646 13.111-10.224 29.284-10.224 16.171 0 29.282 4.578 29.281 10.225 0 5.646-13.109 10.224-29.281 10.224z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__b)",
  d: "M135.57 135.992c-18.39 0-33.298 5.206-33.298 11.627s14.908 11.627 33.298 11.627 33.299-5.206 33.299-11.627c0-6.424-14.913-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.577-29.282-10.224s13.11-10.225 29.282-10.225 29.283 4.578 29.283 10.225c0 5.644-13.106 10.222-29.277 10.224z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 148.619c15.929 0 28.841-2.602 28.841-5.813s-12.912-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.913 5.813 28.841 5.813",
  opacity: 0.15
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M168.781 150.426v9.021c-1.194 3.608-9.596 10.825-33.658 10.825s-31.987-6.014-32.942-9.021v-12.629s0 10.825 32.942 10.825 33.658-10.825 33.658-10.825z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 155.017c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 153.93c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 135.601c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.281 0-4.572 13.111-8.28 29.284-8.279 16.171 0 29.282 3.707 29.281 8.28 0 4.572-13.109 8.279-29.281 8.28z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__c)",
  d: "M135.57 135.098c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 145.325c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 146.251c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 145.164c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 126.834c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.28 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.281 8.281 0 4.572-13.109 8.279-29.281 8.279z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__d)",
  d: "M135.57 126.332c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 136.558c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M168.781 138.021v7.306c-1.194 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305V136.56s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M131.273 143.747c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M131.273 142.66c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M131.273 124.33c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.28 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.708 29.281 8.281 0 4.572-13.109 8.279-29.281 8.279z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__e)",
  d: "M131.273 123.828c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M131.273 134.055c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M131.273 134.981c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M131.273 133.893c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M131.273 115.564c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.28 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.281 8.281 0 4.572-13.109 8.279-29.281 8.279z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__f)",
  d: "M131.273 115.062c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.695c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.279-29.277 8.28z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M131.273 125.288c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M164.484 126.751v7.305c-1.194 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305V125.29s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M137.002 134.087c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M137.002 133c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416S118.612 133 137.002 133"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M137.002 114.67c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.695c-16.172 0-29.283-3.708-29.282-8.281 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.708 29.281 8.281 0 4.572-13.109 8.279-29.281 8.28z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__g)",
  d: "M137.002 114.168c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M137.002 124.394c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M137.002 125.32c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M137.002 124.234c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M137.002 105.904c-18.39 0-33.298 4.215-33.298 9.415 0 5.201 14.908 9.416 33.298 9.416s33.299-4.215 33.299-9.416-14.913-9.417-33.304-9.415zm0 17.694c-16.172 0-29.283-3.707-29.282-8.281 0-4.572 13.111-8.279 29.284-8.279 16.171 0 29.282 3.707 29.281 8.28 0 4.573-13.109 8.28-29.281 8.28z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__h)",
  d: "M137.002 105.402c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.203-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.708-29.282-8.28 0-4.573 13.11-8.281 29.282-8.281s29.283 3.708 29.283 8.281c0 4.571-13.106 8.278-29.277 8.28z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M137.002 115.628c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M170.213 117.09v7.305c-1.194 2.923-9.596 8.767-33.658 8.767s-31.987-4.87-32.942-7.306v-10.227s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 122.817c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 121.729c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 103.4c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.281 0-4.572 13.111-8.279 29.284-8.279 16.171 0 29.282 3.707 29.281 8.281 0 4.572-13.109 8.279-29.281 8.279z"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__i)",
  d: "M135.57 102.897c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 113.124c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 114.05c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 112.963c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 94.634c-18.39 0-33.298 4.215-33.298 9.415 0 5.201 14.908 9.416 33.298 9.416s33.299-4.215 33.299-9.416-14.913-9.417-33.304-9.415zm0 17.694c-16.173 0-29.283-3.707-29.282-8.281 0-4.572 13.111-8.28 29.284-8.28 16.171 0 29.282 3.708 29.281 8.281 0 4.573-13.109 8.28-29.281 8.28z"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__j)",
  d: "M135.57 94.131c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 104.357c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M168.781 105.82v7.305c-1.194 2.923-9.596 8.767-33.658 8.767s-31.987-4.87-32.942-7.306v-10.227s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 108.325c18.39 0 33.298-4.215 33.298-9.415s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.415 33.299 9.415"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 107.239c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 88.91c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.28 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.281 8.28 0 4.573-13.109 8.28-29.281 8.28z"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__k)",
  d: "M135.57 88.407c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 98.633c15.929 0 28.841-2.107 28.841-4.707s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.707 28.841 4.707",
  opacity: 0.15
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 99.56c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.415 33.299 9.415"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 98.472c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.415-33.298-9.415-33.299 4.215-33.299 9.415 14.909 9.416 33.299 9.416"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 80.144c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.28 0-4.574 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.281 8.28 0 4.572-13.109 8.28-29.281 8.28z"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__l)",
  d: "M135.57 79.64c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.571-13.106 8.279-29.277 8.28z"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 89.867c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M168.781 91.33v7.305c-1.194 2.922-9.596 8.767-33.658 8.767s-31.987-4.871-32.942-7.306V89.869s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 95.446c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M138.435 94.358c18.39 0 33.299-4.215 33.299-9.416 0-5.2-14.909-9.415-33.299-9.415s-33.299 4.215-33.299 9.415 14.909 9.416 33.299 9.416"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 76.03c-18.391 0-33.299 4.215-33.299 9.415s14.908 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.693c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.28 0 4.573-13.109 8.28-29.28 8.28z"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__m)",
  d: "M138.435 75.527c-18.391 0-33.299 4.215-33.299 9.415s14.908 9.416 33.299 9.416 33.298-4.215 33.298-9.416-14.912-9.417-33.304-9.415zm0 17.696c-16.173 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.57-13.106 8.278-29.277 8.28z"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M138.435 85.753c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 86.679c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.415-33.299-9.415-33.299 4.215-33.299 9.415 14.909 9.416 33.299 9.416"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M138.435 85.592c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 67.263c-18.391 0-33.299 4.215-33.299 9.415s14.908 9.416 33.299 9.416 33.298-4.215 33.298-9.416-14.912-9.417-33.304-9.415zm0 17.694c-16.173 0-29.284-3.708-29.283-8.28 0-4.573 13.112-8.28 29.285-8.28 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.28-29.28 8.28z"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__n)",
  d: "M138.435 66.76c-18.391 0-33.299 4.216-33.299 9.416s14.908 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.418-33.304-9.416zm0 17.696c-16.173 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.57-13.106 8.278-29.277 8.28z"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M138.435 76.987c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M171.645 78.45v7.305c-1.193 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305V76.988s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767z"
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 82.565c18.39 0 33.299-4.215 33.299-9.415s-14.909-9.416-33.299-9.416-33.299 4.215-33.299 9.416c0 5.2 14.909 9.415 33.299 9.415"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M138.435 81.478c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 63.149c-18.391 0-33.299 4.216-33.299 9.416s14.908 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.203-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.707 29.28 8.28s-13.109 8.28-29.28 8.28z"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__o)",
  d: "M138.435 62.647c-18.391 0-33.299 4.215-33.299 9.415s14.908 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.695c-16.173 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.279-29.277 8.28z"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M138.435 72.873c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 73.8c18.39 0 33.299-4.216 33.299-9.417s-14.909-9.415-33.299-9.415-33.299 4.215-33.299 9.415 14.909 9.416 33.299 9.416"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M138.435 72.712c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M138.435 54.382c-18.391 0-33.299 4.216-33.299 9.416s14.908 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.28-29.28 8.28z"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__p)",
  d: "M138.435 53.88c-18.391 0-33.299 4.216-33.299 9.416s14.908 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.696c-16.173 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.278-29.277 8.28z"
})), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M138.435 64.107c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M171.645 65.57v7.305c-1.193 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305V64.108s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767z"
})), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 69.685c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 68.598c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.415 33.299 9.415"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 50.269c-18.39 0-33.298 4.215-33.298 9.415S117.18 69.1 135.57 69.1s33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.28 0-4.574 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.281 8.28 0 4.572-13.109 8.28-29.281 8.28z"
})), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__q)",
  d: "M135.57 49.766c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.57-13.106 8.278-29.277 8.28z"
})), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 59.993c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 60.919c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M135.57 59.831c18.39 0 33.298-4.215 33.298-9.415S153.96 41 135.57 41s-33.299 4.216-33.299 9.416 14.909 9.415 33.299 9.415"
})), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M135.57 41.502c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.695c-16.173 0-29.283-3.708-29.282-8.281 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.708 29.281 8.281 0 4.572-13.109 8.28-29.281 8.28z"
})), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__r)",
  d: "M135.57 41c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.283 3.707 29.283 8.28c0 4.57-13.106 8.278-29.277 8.28z"
})), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M135.57 51.226c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.707-28.841-4.707-28.841 2.107-28.841 4.707 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M168.781 52.69v7.305c-1.194 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305V51.228s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767zM78.28 185.904c18.39 0 33.298-5.206 33.298-11.627S96.67 162.65 78.28 162.65s-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M78.28 184.561c18.39 0 33.298-5.206 33.298-11.627S96.67 161.307 78.28 161.307s-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M78.28 161.928c-18.39 0-33.299 5.205-33.299 11.626 0 6.422 14.909 11.627 33.299 11.627s33.298-5.205 33.298-11.627-14.912-11.628-33.304-11.626zm0 21.849c-16.173 0-29.284-4.578-29.282-10.225 0-5.647 13.11-10.224 29.284-10.224 16.17 0 29.281 4.578 29.28 10.225s-13.109 10.223-29.28 10.224z"
})), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__s)",
  d: "M78.28 161.307c-18.39 0-33.299 5.206-33.299 11.627S59.89 184.56 78.28 184.56s33.298-5.205 33.298-11.626c0-6.424-14.912-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.577-29.282-10.224s13.11-10.225 29.282-10.225 29.282 4.578 29.282 10.225c0 5.644-13.106 10.222-29.277 10.224z"
})), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M78.28 173.934c15.928 0 28.841-2.602 28.841-5.813s-12.913-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.912 5.813 28.84 5.813",
  opacity: 0.15
})), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M78.28 175.079c18.39 0 33.298-5.206 33.298-11.627S96.67 151.825 78.28 151.825s-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M78.28 173.736c18.39 0 33.298-5.206 33.298-11.627S96.67 150.482 78.28 150.482s-33.299 5.206-33.299 11.627 14.909 11.627 33.299 11.627"
})), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M78.28 151.103c-18.39 0-33.299 5.205-33.299 11.626s14.909 11.627 33.299 11.627 33.298-5.206 33.298-11.627c0-6.423-14.912-11.629-33.304-11.626zm0 21.849c-16.173 0-29.284-4.578-29.282-10.225 0-5.647 13.11-10.224 29.284-10.224 16.17 0 29.281 4.578 29.28 10.225s-13.109 10.223-29.28 10.224z"
})), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__t)",
  d: "M78.28 150.482c-18.39 0-33.299 5.206-33.299 11.627s14.909 11.627 33.299 11.627 33.298-5.206 33.298-11.627c0-6.424-14.912-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.577-29.282-10.224s13.11-10.224 29.282-10.224 29.282 4.577 29.282 10.224c0 5.644-13.106 10.222-29.277 10.224z"
})), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M78.28 163.109c15.928 0 28.841-2.602 28.841-5.813s-12.913-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.912 5.813 28.84 5.813",
  opacity: 0.15
})), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M111.49 164.916v9.021c-1.193 3.608-9.596 10.825-33.658 10.825s-31.987-6.014-32.942-9.021v-12.629s0 10.825 32.942 10.825 33.658-10.825 33.658-10.825z"
})), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 171.118c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M84.725 170.03c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 151.701c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.418-33.305-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.28 0-4.573 13.11-8.28 29.284-8.28 16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__u)",
  d: "M84.725 151.199c-18.39 0-33.298 4.215-33.298 9.415 0 5.201 14.908 9.416 33.298 9.416s33.299-4.215 33.299-9.416-14.913-9.417-33.305-9.415zm0 17.695c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.279-29.276 8.28z"
})), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M84.725 161.425c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 162.351c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M84.725 161.264c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 142.935c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.305-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.281 0-4.572 13.11-8.28 29.284-8.279 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.279-29.28 8.28z"
})), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__v)",
  d: "M84.725 142.433c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.305-9.415zm0 17.695c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.279-29.276 8.28z"
})), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M84.725 152.659c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M117.936 154.121v7.306c-1.194 2.922-9.597 8.766-33.659 8.766s-31.987-4.87-32.941-7.305V152.66s0 8.767 32.941 8.767 33.659-8.767 33.659-8.767z"
})), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 159.847c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M84.725 158.76c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 140.431c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.305-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.281 0-4.572 13.11-8.28 29.284-8.279 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.28-29.28 8.28z"
})), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__w)",
  d: "M84.725 139.928c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.418-33.305-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.278-29.276 8.28z"
})), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M84.725 150.155c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 151.081c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M84.725 149.994c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M84.725 131.665c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.305-9.415zm0 17.694c-16.173 0-29.283-3.708-29.282-8.281 0-4.572 13.11-8.28 29.284-8.279 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.279-29.28 8.28z"
})), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__x)",
  d: "M84.725 131.162c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.305-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.278-29.276 8.28z"
})), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M84.725 141.388c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M117.936 142.851v7.305c-1.194 2.922-9.597 8.767-33.659 8.767s-31.987-4.871-32.941-7.306V141.39s0 8.766 32.941 8.766 33.659-8.766 33.659-8.766z"
})), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 148.577c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M89.022 147.49c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 129.16c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__y)",
  d: "M89.022 128.658c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.418-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.278-29.277 8.28z"
})), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M89.022 138.885c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 139.811c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M89.022 138.723c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 120.394c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__z)",
  d: "M89.022 119.892c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.695c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.279-29.277 8.28z"
})), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M89.022 130.118c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M122.232 131.581v7.305c-1.193 2.922-9.596 8.767-33.658 8.767s-31.987-4.871-32.942-7.306V130.12s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M83.293 137.307c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.908 9.416 33.299 9.416"
})), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M83.293 136.219c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.908 9.416 33.299 9.416"
})), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M83.293 117.89c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.17 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__A)",
  d: "M83.293 117.388c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.695c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.279-29.277 8.28z"
})), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M83.293 127.614c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M83.293 128.541c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.908 9.416 33.299 9.416"
})), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M83.293 127.453c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.908 9.416 33.299 9.416"
})), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M83.293 109.124c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.694c-16.173 0-29.284-3.708-29.283-8.281s13.112-8.28 29.285-8.279c16.17 0 29.281 3.707 29.28 8.28s-13.109 8.279-29.28 8.28z"
})), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__B)",
  d: "M83.293 108.622c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.695c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.279-29.277 8.28z"
})), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M83.293 118.848c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M116.503 120.311v7.305c-1.193 2.922-9.596 8.767-33.658 8.767s-31.987-4.871-32.942-7.306V118.85s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 124.426c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M89.022 123.339c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 105.01c-18.39 0-33.299 4.215-33.299 9.415 0 5.201 14.909 9.416 33.299 9.416s33.298-4.215 33.298-9.416-14.912-9.417-33.304-9.415zm0 17.694c-16.173 0-29.284-3.707-29.283-8.281 0-4.572 13.112-8.279 29.285-8.279 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.28-29.28 8.28z"
})), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__C)",
  d: "M89.022 104.507c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.278-29.277 8.28z"
})), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M89.022 114.734c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 115.66c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M89.022 114.573c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M89.022 96.244c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.694c-16.173 0-29.284-3.708-29.283-8.281 0-4.572 13.112-8.28 29.285-8.28 16.171 0 29.281 3.708 29.28 8.281s-13.109 8.28-29.28 8.28z"
})), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__D)",
  d: "M89.022 95.741c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.11-8.28 29.283-8.28c16.172 0 29.282 3.707 29.282 8.28 0 4.571-13.106 8.278-29.277 8.28z"
})), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M89.022 105.968c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708S60.18 98.66 60.18 101.26s12.912 4.708 28.84 4.708",
  opacity: 0.15
})), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M122.232 107.43v7.306c-1.193 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305v-10.228s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767zM206.467 182.683c18.39 0 33.299-5.206 33.299-11.627s-14.909-11.627-33.299-11.627-33.298 5.206-33.298 11.627 14.908 11.627 33.298 11.627"
})), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M206.467 181.341c18.39 0 33.299-5.206 33.299-11.627s-14.909-11.627-33.299-11.627-33.298 5.206-33.298 11.627 14.908 11.627 33.298 11.627"
})), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M206.467 158.708c-18.39 0-33.299 5.205-33.299 11.627 0 6.421 14.909 11.626 33.299 11.626s33.298-5.205 33.298-11.626c0-6.424-14.912-11.629-33.304-11.627zm0 21.849c-16.173 0-29.283-4.578-29.282-10.225 0-5.646 13.111-10.224 29.284-10.224 16.171 0 29.281 4.578 29.28 10.225s-13.109 10.224-29.28 10.224z"
})), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__E)",
  d: "M206.467 158.087c-18.39 0-33.299 5.205-33.299 11.627 0 6.421 14.909 11.626 33.299 11.626s33.298-5.205 33.298-11.626c0-6.424-14.912-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.578-29.282-10.224 0-5.647 13.11-10.225 29.282-10.225s29.282 4.578 29.282 10.225c0 5.644-13.106 10.222-29.277 10.224z"
})), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M206.467 170.715c15.928 0 28.841-2.602 28.841-5.813s-12.913-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.912 5.813 28.841 5.813",
  opacity: 0.15
})), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M206.467 171.859c18.39 0 33.299-5.206 33.299-11.627s-14.909-11.627-33.299-11.627-33.298 5.206-33.298 11.627 14.908 11.627 33.298 11.627"
})), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M206.467 170.516c18.39 0 33.299-5.206 33.299-11.627s-14.909-11.627-33.299-11.627-33.298 5.206-33.298 11.627 14.908 11.627 33.298 11.627"
})), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M206.467 147.883c-18.39 0-33.299 5.205-33.299 11.626 0 6.422 14.909 11.627 33.299 11.627s33.298-5.205 33.298-11.627-14.912-11.628-33.304-11.626zm0 21.849c-16.173 0-29.283-4.578-29.282-10.225 0-5.646 13.111-10.224 29.284-10.224 16.171 0 29.281 4.578 29.28 10.225s-13.109 10.224-29.28 10.224z"
})), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__F)",
  d: "M206.467 147.262c-18.39 0-33.299 5.206-33.299 11.627s14.909 11.627 33.299 11.627 33.298-5.206 33.298-11.627c0-6.424-14.912-11.629-33.304-11.627zm0 21.851c-16.172 0-29.282-4.577-29.282-10.224s13.11-10.225 29.282-10.225 29.282 4.578 29.282 10.225c0 5.644-13.106 10.222-29.277 10.224z"
})), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M206.467 159.89c15.928 0 28.841-2.602 28.841-5.813s-12.913-5.813-28.841-5.813-28.841 2.602-28.841 5.813 12.912 5.813 28.841 5.813",
  opacity: 0.15
})), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M239.677 161.696v9.021c-1.193 3.608-9.596 10.825-33.658 10.825s-31.987-6.014-32.942-9.021v-12.629s0 10.825 32.942 10.825 33.658-10.825 33.658-10.825z"
})), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 167.898c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M201.454 166.81c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 148.48c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.695c-16.173 0-29.283-3.708-29.282-8.281 0-4.573 13.111-8.28 29.284-8.279 16.171 0 29.282 3.707 29.28 8.28 0 4.572-13.109 8.279-29.28 8.28z"
})), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__G)",
  d: "M201.454 147.979c-18.39 0-33.298 4.215-33.298 9.415s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.415zm0 17.695c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.279-29.276 8.28z"
})), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M201.454 158.205c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 159.131c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M201.454 158.044c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 139.714c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.416 33.298 9.416 33.299-4.216 33.299-9.416c0-5.202-14.913-9.417-33.304-9.416zm0 17.695c-16.173 0-29.283-3.708-29.282-8.281 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.28z"
})), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__H)",
  d: "M201.454 139.212c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.278-29.276 8.28z"
})), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M201.454 149.439c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M234.665 150.901v7.305c-1.194 2.923-9.597 8.767-33.659 8.767s-31.987-4.87-32.941-7.306V149.44s0 8.766 32.941 8.766 33.659-8.766 33.659-8.766z"
})), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 156.627c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M201.454 155.54c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 137.211c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.28 0-4.573 13.111-8.28 29.284-8.28 16.171 0 29.282 3.707 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__I)",
  d: "M201.454 136.708c-18.39 0-33.298 4.216-33.298 9.416s14.908 9.415 33.298 9.415 33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.278-29.276 8.28z"
})), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M201.454 146.935c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 147.861c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M201.454 146.774c18.39 0 33.299-4.216 33.299-9.416s-14.909-9.416-33.299-9.416-33.298 4.216-33.298 9.416 14.908 9.416 33.298 9.416"
})), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M201.454 128.444c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.203-14.913-9.418-33.304-9.416zm0 17.694c-16.173 0-29.283-3.707-29.282-8.281 0-4.572 13.111-8.279 29.284-8.279 16.171 0 29.282 3.707 29.28 8.28 0 4.573-13.109 8.28-29.28 8.28z"
})), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__J)",
  d: "M201.454 127.942c-18.39 0-33.298 4.215-33.298 9.416 0 5.2 14.908 9.415 33.298 9.415s33.299-4.215 33.299-9.415c0-5.202-14.913-9.418-33.304-9.416zm0 17.696c-16.172 0-29.282-3.707-29.282-8.28s13.11-8.28 29.282-8.28 29.282 3.707 29.282 8.28c0 4.571-13.105 8.278-29.276 8.28z"
})), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M201.454 138.168c15.928 0 28.841-2.108 28.841-4.708s-12.913-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.912 4.708 28.841 4.708",
  opacity: 0.15
})), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M234.665 139.631v7.305c-1.194 2.923-9.597 8.767-33.659 8.767s-31.987-4.87-32.941-7.306V138.17s0 8.766 32.941 8.766 33.659-8.766 33.659-8.766z"
})), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 145.357c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M205.751 144.27c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 125.94c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.695c-16.173 0-29.284-3.708-29.283-8.281s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.28z"
})), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__K)",
  d: "M205.751 125.438c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.111-8.28 29.283-8.28 29.282 3.707 29.282 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M205.751 135.664c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 136.59c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M205.751 135.503c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 117.174c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__L)",
  d: "M205.751 116.671c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.111-8.28 29.283-8.28 29.282 3.707 29.282 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M205.751 126.898c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M238.961 128.36v7.306c-1.193 2.922-9.596 8.766-33.658 8.766s-31.987-4.87-32.942-7.305v-10.228s0 8.767 32.942 8.767 33.658-8.767 33.658-8.767z"
})), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M200.022 134.087c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M200.022 133c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416S181.632 133 200.022 133"
})), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M200.022 114.67c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.416zm0 17.695c-16.173 0-29.284-3.708-29.283-8.281s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.28z"
})), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__M)",
  d: "M200.022 114.168c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.111-8.28 29.283-8.28 29.282 3.707 29.282 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M200.022 124.394c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M200.022 125.32c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M200.022 124.234c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M200.022 105.904c-18.39 0-33.299 4.215-33.299 9.415 0 5.201 14.909 9.416 33.299 9.416s33.298-4.215 33.298-9.416-14.912-9.417-33.304-9.415zm0 17.694c-16.173 0-29.284-3.707-29.283-8.281 0-4.572 13.112-8.279 29.285-8.279 16.171 0 29.281 3.707 29.28 8.28s-13.109 8.28-29.28 8.28z"
})), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__N)",
  d: "M200.022 105.402c-18.39 0-33.299 4.215-33.299 9.416 0 5.2 14.909 9.415 33.299 9.415s33.298-4.215 33.298-9.415c0-5.203-14.912-9.418-33.304-9.416zm0 17.696c-16.172 0-29.283-3.708-29.283-8.28 0-4.573 13.111-8.281 29.283-8.281s29.282 3.708 29.282 8.281c0 4.571-13.106 8.278-29.277 8.28z"
})), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M200.022 115.628c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M233.232 117.09v7.305c-1.193 2.923-9.596 8.767-33.658 8.767s-31.987-4.87-32.942-7.306v-10.227s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766z"
})), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 121.206c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M205.751 120.119c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 101.79c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.708 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__O)",
  d: "M205.751 101.288c-18.39 0-33.299 4.215-33.299 9.415s14.909 9.416 33.299 9.416 33.298-4.216 33.298-9.416c0-5.202-14.912-9.417-33.304-9.415zm0 17.695c-16.172 0-29.283-3.707-29.283-8.28s13.111-8.28 29.283-8.28 29.282 3.707 29.282 8.28c0 4.571-13.106 8.279-29.277 8.28z"
})), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M205.751 111.514c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.708-28.841-4.708-28.841 2.108-28.841 4.708 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 112.44c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M205.751 111.353c18.39 0 33.298-4.216 33.298-9.416s-14.908-9.416-33.298-9.416-33.299 4.216-33.299 9.416 14.909 9.416 33.299 9.416"
})), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M205.751 93.024c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.203-14.912-9.418-33.304-9.416zm0 17.694c-16.173 0-29.284-3.707-29.283-8.28s13.112-8.28 29.285-8.28c16.171 0 29.281 3.707 29.28 8.281 0 4.572-13.109 8.279-29.28 8.279z"
})), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__P)",
  d: "M205.751 92.521c-18.39 0-33.299 4.216-33.299 9.416s14.909 9.415 33.299 9.415 33.298-4.215 33.298-9.415c0-5.202-14.912-9.418-33.304-9.416zm0 17.696c-16.172 0-29.283-3.707-29.283-8.28s13.111-8.28 29.283-8.28 29.282 3.707 29.282 8.28c0 4.571-13.106 8.278-29.277 8.28z"
})), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M205.751 102.747c15.929 0 28.841-2.108 28.841-4.708s-12.912-4.707-28.841-4.707-28.841 2.107-28.841 4.707 12.913 4.708 28.841 4.708",
  opacity: 0.15
})), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M238.961 104.21v7.305c-1.193 2.923-9.596 8.767-33.658 8.767s-31.987-4.87-32.942-7.305v-10.228s0 8.766 32.942 8.766 33.658-8.766 33.658-8.766zM182.531 191.997c17.881-4.298 28.892-22.278 24.593-40.159s-22.278-28.892-40.159-24.593-28.892 22.278-24.593 40.159 22.278 28.892 40.159 24.593"
})), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E4A020)",
  d: "M181.632 188.258c17.881-4.298 28.892-22.278 24.593-40.159s-22.278-28.892-40.159-24.593-28.892 22.278-24.593 40.159 22.278 28.892 40.159 24.593"
})), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #E18A04)",
  d: "M166.482 125.233c-17.881 4.299-28.892 22.278-24.593 40.159s22.278 28.892 40.159 24.594c17.881-4.299 28.891-22.279 24.593-40.16-4.3-17.887-22.284-28.896-40.165-24.592zm14.626 60.842c-15.725 3.78-31.537-5.903-35.316-21.629-3.78-15.723 5.904-31.535 21.629-35.314 15.723-3.779 31.535 5.904 35.314 21.629 3.78 15.722-5.903 31.533-21.627 35.314"
})), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#token-group_svg__Q)",
  d: "M166.067 123.506c-17.881 4.298-28.892 22.278-24.594 40.159 4.299 17.881 22.279 28.891 40.159 24.593 17.881-4.298 28.892-22.278 24.594-40.159-4.3-17.888-22.284-28.897-40.165-24.592zm14.627 60.847c-15.725 3.78-31.536-5.903-35.316-21.627s5.903-31.536 21.627-35.316 31.536 5.903 35.316 21.628c3.778 15.717-5.9 31.528-21.622 35.314z"
})), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, white)",
  d: "M174.52 158.667c15.487-3.723 26.299-13.989 24.15-22.929-2.149-8.941-16.446-13.17-31.933-9.447-15.488 3.723-26.3 13.989-24.151 22.929 2.149 8.941 16.446 13.17 31.934 9.447",
  opacity: 0.15
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#token-group_svg__R)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #FFED2E)",
  d: "m160.606 142.832 5.228-1.355a275 275 0 0 1 4.983-1.247q3.337-.803 5.923-.412 2.606.36 4.296 1.954 1.709 1.563 2.382 4.364a7.1 7.1 0 0 1-.013 3.434 7.2 7.2 0 0 1-1.506 2.978 6.3 6.3 0 0 1-2.73 1.891l-.174-.724q1.936-.366 3.897.397 1.978.734 3.483 2.371 1.498 1.615 2.043 3.878.706 2.94-.101 5.331-.784 2.386-3.064 4.094-2.286 1.685-6.019 2.582-2.754.663-5.454 1.237-2.672.594-5.477 1.243l-.406-.248-7.539-31.363zm12.516 26.291q1.296-.36 2.509-.652l2.24-.539q1.657-.398 2.595-1.117.932-.743 1.336-1.63a4.5 4.5 0 0 0 .395-1.847 6.8 6.8 0 0 0-.171-1.737q-.263-1.096-1.034-2.145-.753-1.078-2.162-1.603-1.393-.554-3.562-.033l-7.001 1.683-1.1-4.573 6.511-1.565q1.867-.45 2.713-1.344.864-.923 1.002-1.993a5.4 5.4 0 0 0-.08-2.079 5.6 5.6 0 0 0-.856-1.917q-.603-.867-1.758-1.256t-3.022.06l-1.983.477q-1.173.257-2.182.475z"
}))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #F8C501)",
  d: "M180 0s1.379 12.875 6.752 18.248S205 25 205 25s-12.875 1.38-18.248 6.752C181.379 37.125 180 50 180 50s-1.379-12.875-6.752-18.248S155 25 155 25s12.875-1.38 18.248-6.752C178.621 12.875 180 0 180 0M16 78s.883 8.24 4.322 11.679S32 94 32 94s-8.24.883-11.678 4.322C16.882 101.76 16 110 16 110s-.883-8.24-4.321-11.678C8.239 94.882 0 94 0 94s8.24-.883 11.679-4.321C15.117 86.239 16 78 16 78M270.5 73s1.186 11.072 5.807 15.693C280.928 93.313 292 94.5 292 94.5s-11.072 1.186-15.693 5.807S270.5 116 270.5 116s-1.186-11.072-5.807-15.693C260.072 95.687 249 94.5 249 94.5s11.072-1.186 15.693-5.807C269.314 84.073 270.5 73 270.5 73"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__a",
  x1: 110.525,
  x2: 115.093,
  y1: 175.363,
  y2: 150.049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__b",
  x1: 110.525,
  x2: 115.093,
  y1: 164.539,
  y2: 139.225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__c",
  x1: 110.525,
  x2: 113.554,
  y1: 158.216,
  y2: 137.491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__d",
  x1: 110.525,
  x2: 113.554,
  y1: 149.45,
  y2: 128.725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__e",
  x1: 106.228,
  x2: 109.257,
  y1: 146.946,
  y2: 126.221,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__f",
  x1: 106.228,
  x2: 109.257,
  y1: 138.18,
  y2: 117.454,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__g",
  x1: 111.957,
  x2: 114.986,
  y1: 137.286,
  y2: 116.561,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__h",
  x1: 111.957,
  x2: 114.986,
  y1: 128.52,
  y2: 107.795,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__i",
  x1: 110.525,
  x2: 113.554,
  y1: 126.015,
  y2: 105.29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__j",
  x1: 110.525,
  x2: 113.554,
  y1: 117.249,
  y2: 96.524,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__k",
  x1: 110.525,
  x2: 113.554,
  y1: 111.525,
  y2: 90.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__l",
  x1: 110.525,
  x2: 113.554,
  y1: 102.759,
  y2: 82.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__m",
  x1: 113.389,
  x2: 116.418,
  y1: 98.645,
  y2: 77.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__n",
  x1: 113.389,
  x2: 116.418,
  y1: 89.878,
  y2: 69.153,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__o",
  x1: 113.389,
  x2: 116.418,
  y1: 85.764,
  y2: 65.039,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__p",
  x1: 113.389,
  x2: 116.418,
  y1: 76.998,
  y2: 56.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__q",
  x1: 110.525,
  x2: 113.554,
  y1: 72.884,
  y2: 52.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__r",
  x1: 110.525,
  x2: 113.554,
  y1: 64.118,
  y2: 43.393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__s",
  x1: 53.234,
  x2: 57.803,
  y1: 189.854,
  y2: 164.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__t",
  x1: 53.234,
  x2: 57.803,
  y1: 179.029,
  y2: 153.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__u",
  x1: 59.679,
  x2: 62.708,
  y1: 174.317,
  y2: 153.592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__v",
  x1: 59.679,
  x2: 62.708,
  y1: 165.551,
  y2: 144.826,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__w",
  x1: 59.679,
  x2: 62.708,
  y1: 163.046,
  y2: 142.321,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__x",
  x1: 59.679,
  x2: 62.708,
  y1: 154.28,
  y2: 133.555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__y",
  x1: 63.976,
  x2: 67.005,
  y1: 151.776,
  y2: 131.051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__z",
  x1: 63.976,
  x2: 67.005,
  y1: 143.01,
  y2: 122.284,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__A",
  x1: 58.247,
  x2: 61.276,
  y1: 140.506,
  y2: 119.781,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__B",
  x1: 58.247,
  x2: 61.276,
  y1: 131.74,
  y2: 111.014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__C",
  x1: 63.976,
  x2: 67.005,
  y1: 127.625,
  y2: 106.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__D",
  x1: 63.976,
  x2: 67.005,
  y1: 118.859,
  y2: 98.134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__E",
  x1: 181.421,
  x2: 185.99,
  y1: 186.633,
  y2: 161.32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__F",
  x1: 181.421,
  x2: 185.99,
  y1: 175.809,
  y2: 150.495,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__G",
  x1: 176.408,
  x2: 179.437,
  y1: 171.097,
  y2: 150.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__H",
  x1: 176.408,
  x2: 179.437,
  y1: 162.33,
  y2: 141.605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__I",
  x1: 176.408,
  x2: 179.437,
  y1: 159.826,
  y2: 139.101,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__J",
  x1: 176.408,
  x2: 179.437,
  y1: 151.06,
  y2: 130.335,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__K",
  x1: 180.705,
  x2: 183.734,
  y1: 148.556,
  y2: 127.831,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__L",
  x1: 180.705,
  x2: 183.734,
  y1: 139.789,
  y2: 119.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__M",
  x1: 174.976,
  x2: 178.005,
  y1: 137.286,
  y2: 116.561,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__N",
  x1: 174.976,
  x2: 178.005,
  y1: 128.52,
  y2: 107.795,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__O",
  x1: 180.705,
  x2: 183.734,
  y1: 124.406,
  y2: 103.68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__P",
  x1: 180.705,
  x2: 183.734,
  y1: 115.639,
  y2: 94.914,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "token-group_svg__Q",
  x1: 160.824,
  x2: 176.704,
  y1: 208.852,
  y2: 144.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD800"
})), /*#__PURE__*/React.createElement("filter", {
  id: "token-group_svg__R",
  width: 34.39,
  height: 41.158,
  x: 157.358,
  y: 138.69,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.109804 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0_6"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0_6",
  result: "shape"
})))));
export default SvgTokenGroup;